import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <p>© 2026 Tradeye. All rights reserved.</p>
  </footer>
);

export default Footer;
